import { combineReducers } from 'redux'
import _ from 'lodash'

import {
  SET_IMAGE,
  RESET_IMAGE,
  SET_UID,
  RESET_UID,
  FETCH_GRAPHICS_OUTPUT,
  FETCH_GRAPHICS_OUTPUT_SUCCESS,
  FETCH_CAMERA_IMAGE,
  FETCH_CAMERA_IMAGE_SUCCESS,
} from 'react-redux/actions/media-player'

import { RESET } from 'react-redux/actions/app'

/* Assets */
import blank from 'assets/blank.png'

const initialState = {
  image: blank,
  type: null,
  uid: ""
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET: {
      return _.cloneDeep(initialState)
    }
    case FETCH_GRAPHICS_OUTPUT: {
      return Object.assign({}, state, { type: 0, uid: action.payload.uid })
    }
    case FETCH_GRAPHICS_OUTPUT_SUCCESS: {
      return Object.assign({}, state, { image: action.payload })
    }
    case FETCH_CAMERA_IMAGE: {
      return Object.assign({}, state, { type: 1, uid: action.payload.uid })
    }
    case FETCH_CAMERA_IMAGE_SUCCESS: {
      return Object.assign({}, state,  { image: action.payload })
    }
    case SET_IMAGE: {
      return Object.assign({}, state, { image: action.payload })
    }
    case RESET_IMAGE: {
      return Object.assign({}, state,  { image: initialState.image })
    }
    case SET_UID: {
      return Object.assign({}, state, { uid: action.uid })
    }
    case RESET_UID: {
      return Object.assign({}, state,  { uid: initialState.uid })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/snapshot.js